import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

import {AgentModel} from "./angular/models/agent.model";
import {BringozObject} from "../persistence-layer/bringoz-object";

angular
  .module('bringoz.admin.agents')
  .factory('$agent', AgentObjectFactory);


export type $agentFactory = (id: string) => BringozObject<AgentModel>;

/* @ngInject */
function AgentObjectFactory($bringozFactory: $bringozFactory,
                            AgentsAPI: BringozApi,
                            Agents_DS: DataStoreConfig,
                            Agents_PN: PushNotificationsConfig) {
  function $agent(id: string) {
    return $bringozFactory<AgentModel>(id, AgentsAPI, Agents_DS, Agents_PN)
  }

  return $agent;
}
